Auth = require 'db/auth'
BoardListAnnouncementComponent = require 'views/board-list/board-list-announcement-component'
BoardsPageAnnouncement = require 'data/boards-page-announcement'
ChangeEmailFreqPopoverView = require 'views/member/change-email-freq-popover-view'
DesktopNotification = require 'views/lib/desktop-notification'
Dialog = require 'views/lib/dialog'
ModelCache = require 'db/model-cache'
ModelCacheListener = require 'views/internal/model-cache-listener'
ModelLoader = require 'db/model-loader'
Notification = require 'models/notification'
NotificationGroup = require 'models/collections/notification-group'
NotificationList = require 'views/notification/notification-list'
NPSComponent = require 'views/nps/nps-component'
PopOver = require 'views/lib/pop-over'
React = require 'react'
SimpleTest = require 'lib/experiments/simple-test'
recup = require 'recup'
Util = require 'lib/util'
t = require('views/internal/recup-with-helpers')('header_notification_list_menu')
track = require 'debug/track'
logError = require 'debug/log-error'
_ = require 'underscore'
$ = require 'jquery'
moment = require 'moment'
{ VISIBILITY_ALL, VISIBILITY_UNREAD } = require './visibility-states'

class HeaderNotificationListView extends React.Component
  displayName: 'HeaderNotifications'

  constructor: (props) ->
    this.state = _.extend {}, {
      canAllowDesktopNotifications: DesktopNotification.notEnabled()
      surveyDismissed: false
      visibilityFilter: VISIBILITY_UNREAD
    }, @getNotificationState()

  componentDidMount: ->
    @mounted = true
    isShowCards = SimpleTest('cardNotifications').get('showCards')

    if isShowCards
      @props.listenTo 'change:Notification', _.debounce(@refresh.bind(@), 100)
    else
      @props.listenTo 'add:Notification remove:Notification change:Notification', _.debounce(@updateNotifications.bind(@), 100)

    @props.listenTo 'change:Member:oneTimeMessagesDismissed', @refresh.bind(@)

  componentWillUnmount: ->
    @mounted = false
    @_notificationPermissionPromise?.cancel()

  updateNotifications: ->
    # Quick hack around making sure this setState doesn't get called by the debounced method
    # Underscore never updated their debounce with a cancel method
    if @mounted
      @setState @getNotificationState()

  refresh: ->
    if @mounted
      @setState @getNotificationState(true)

  getNotificationState: (refresh = false)->
    isShowCards = SimpleTest('cardNotifications').get('showCards')

    if isShowCards
      notifications = if refresh then @state.notifications else new NotificationGroup(ModelCache.all('Notification'))
      totalUnreadNotifications = notifications.totalUnreadNotifications()
    else
      notifications = Notification.sortedByDateDescending(ModelCache)
      totalUnreadNotifications = notifications.filter((notification) -> notification.get('unread')).length

    {
      notifications: notifications
      totalUnreadNotifications: totalUnreadNotifications
    }

  _getOrSet: (key, value) ->
    isSet = localStorage.getItem key
    if !isSet?
      localStorage.setItem key, value

    return isSet ? value

  getBanner:  ->
    # The banner and feedback form is not localized,
    # show to english members only
    if !Util.usesEnglish()
      null

    banners = [
      {
        name: 'notifications-grouped-card-feedback'
        exp: SimpleTest('cardNotifications')
        message: ->
          "We're working on notifications. [Tell us what you think](https://trello.typeform.com/to/u7nwwd?memberid=#{ Auth.myId() }&testvar=#{ @exp.get('variation') })!"
        ttl: 300 # 5 minutes
      }
    ]

    banner = _.chain(banners)
      .filter((banner) -> banner.exp.inExperiment)
      .filter((banner) -> !Auth.me().isDismissed(banner.name))
      .last()
      .value()

    # Banner TTL = Time to live
    # How many seconds do we wait until we show the use the banner?
    if banner?.ttl
      timeToWait = @_getOrSet(
        "first-visit-#{banner.name}",
        moment().add(banner.ttl, 's')
      )
      if moment().isAfter(moment(timeToWait))
        banner
    else
      banner

  toggleVisibilityFilter: =>
    visibilityFilter =
      if @state.visibilityFilter == VISIBILITY_UNREAD
        VISIBILITY_ALL
      else
        VISIBILITY_UNREAD
    @setState({ visibilityFilter })

  render: t.renderable ->
    { canAllowDesktopNotifications
    , notifications
    , surveyDismissed
    , totalUnreadNotifications } = @state

    t.div =>
      t.div '.notifications-title', =>
        t.span ->
          t.format 'notifications'
        t.button '.hide-dialog-trigger.dialog-close-button.unstyled-button', {
          onClick: @onHideDialogTriggerClick.bind @
          type: 'button'
        }, =>
          t.icon 'close'


      if @props.showSurvey && !surveyDismissed
        t.createElement NPSComponent, {
          username: Auth.me()?.get('username')
          onDismiss: =>
            @setState(surveyDismissed: true)
            @props.onDismissSurvey()
          submitSurvey: @props.submitSurvey
        }

      if notifications.length == 0
        t.p '.empty', { style: { padding: '24px 6px' } }, ->
          t.format 'no-notifications'
      else
        exp = SimpleTest('cardNotifications')
        t.div
          class: t.classify
            'notification-list-holder': true,
            'u-fancy-scrollbar': true
            'show-cards': exp.get('showCards')
        , =>
          if exp.get('showCards')
            t.div '.notification-actions', =>
              t.button '.visibility-filter.quiet.unstyled-button', {
                href: '#',
                onClick: @toggleVisibilityFilter
              }, =>
                if @state.visibilityFilter == VISIBILITY_UNREAD
                  t.format 'visibility-filter-all'
                else
                  t.format 'visibility-filter-unread'

              if totalUnreadNotifications > 0
                t.button '.mark-all-read.quiet.unstyled-button', {
                  href: '#',
                  onClick: @props.markAllRead
                }, ->
                  t.format 'mark-all-as-read'

          banner = @getBanner()
          if banner?
            recup.createElement BoardListAnnouncementComponent, {
              icon: BoardsPageAnnouncement.icon
              message: banner.message()
              onClick: (e) =>
                if e.target.href?
                  track("Notifications Announcement", "Click", banner.name, e.target.href)
              onDismiss: =>
                Auth.me().dismiss(banner.name)
                track("Notifications Announcement", "Dismiss", banner.name)
            }

          t.createElement NotificationList, {
            notifications,
            context: 'header',
            key: 'NotificationList',
            visibilityFilter: @state.visibilityFilter
            visibilityButtonClicked: @toggleVisibilityFilter
          }

          t.ul '.pop-over-list.mod-add-top-margin', =>
            t.li =>
              t.a '.js-change-email-frequency', { onClick: @changeEmailFrequency.bind(@) }, ->
                t.format 'change-notification-email-frequency'
            if canAllowDesktopNotifications
              t.li =>
                t.a '.js-allow-desktop-notifications', { onClick: @allowDesktopNote.bind(@) }, ->
                  t.format 'allow-desktop-notifications'

  changeEmailFrequency: (e) ->
    Util.stop(e)
    track("Header", "Notifications Menu", "Change Email Frequency")

    PopOver.toggle
      elem: $(e.target)
      view: new ChangeEmailFreqPopoverView({ model: @props.member, modelCache: ModelCache })

    return

  allowDesktopNote: (e) ->
    Util.stop(e)
    track("Header", "Notifications Menu", "Allow Desktop Notifications")

    @_notificationPermissionPromise =
      DesktopNotification.requestPermission()
      .then((__) => @setState canAllowDesktopNotifications: DesktopNotification.notEnabled())
      .catch(=> @setState canAllowDesktopNotifications: false)
      .cancellable()

    return

  onHideDialogTriggerClick: (e) ->
    Util.stop e
    Dialog.hide()

module.exports = ModelCacheListener(HeaderNotificationListView)



// WEBPACK FOOTER //
// ./app/scripts/views/notification/header-notification-list-view.coffee